import { AttributeName, Attributes, FilteredAttributes } from '@domains/product';

import { isValueSet } from '@utils/guards';
import { upperCaseFirstCart } from '@utils/utils';

export const ATTRIBUTES_NAMES: Record<AttributeName, string> = {
    country: 'Бренд, страна',
    // «Производитель» renamed to «Торговая марка» (task 302349): the
    // `manufacturer` field now carries brand values supplied by 1C.
    manufacturer: 'Торговая марка',
};

export const NAME_IS_READY_TO_EAT = 'Готов к употреблению';

export const getBooleanShortName = (flag: boolean) => (flag ? 'Да' : 'Нет');

export const filterAttributes = (attributes: Attributes): FilteredAttributes => {
    const result: FilteredAttributes = {} as FilteredAttributes;
    (Object.keys(attributes) as AttributeName[]).forEach((attributeName) => {
        const value = attributes[attributeName];
        if (value !== null && value.length > 0) {
            result[attributeName] = value;
        }
    });
    return result;
};

export const getAttributesEntries = (
    filteredAttributes: FilteredAttributes,
): [AttributeName, string][] => Object.entries(filteredAttributes) as [AttributeName, string][];

export const getFormattedAttributeName = (name: AttributeName): string =>
    isValueSet(ATTRIBUTES_NAMES[name]) ? ATTRIBUTES_NAMES[name] : upperCaseFirstCart(name);

export const getAvailabilityUrl = (isAvailable: boolean) =>
    isAvailable ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock';
